import { render } from "./cookie.vue?vue&type=template&id=4ed74263"
import script from "./cookie.vue?vue&type=script&lang=js"
export * from "./cookie.vue?vue&type=script&lang=js"

import "./cookie.vue?vue&type=style&index=0&id=4ed74263&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__